import { RecoveryScreen, type RecoveryScreenProps } from './RecoveryScreen';

/**
 * Shown instead of the app when the persisted session could not be loaded — so we cannot say
 * who, if anyone, is signed in. Not a sign-out screen, despite looking like one: see
 * `AuthStatus` for why falling through to the landing page would cost the write queue.
 */
export function SessionErrorScreen({
  onRetry,
  onSignOut,
}: Pick<RecoveryScreenProps, 'onRetry' | 'onSignOut'>) {
  return (
    <RecoveryScreen
      icon="🔑"
      title="Couldn't check your sign-in"
      body="This device couldn't read your saved sign-in. Try again, or sign out to start over."
      onRetry={onRetry}
      onSignOut={onSignOut}
    />
  );
}
